import createBreakpoint from 'shared-tokens/utils/breakpoints';
import getExtPath from 'shared-utils/src/getExtPath';

export const mainCls = 'csa_footer';

const brpM = createBreakpoint('m');
const wImages = 'isVisible';

export default {
  [mainCls]: {
    position: 'relative',
    display: 'flex',
    margin: 0,
    height: 600,
    borderTop: '5px solid',
    [brpM]: {
      height: 400,
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
    '@media print': {
      display: 'none',
    },
  },
  [`${mainCls}--is404`]: {
    '@media (min-width: 768px) and (min-height: 939px)': {      
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
    },
  },
  [`${mainCls}__ctn`]: {
    position: 'relative',
    padding: '52px 32px 0',
    width: '100%',
    [brpM]: {
      margin: '0 auto',
      padding: '67px 32px 0',
      maxWidth: 960,
    },
  },
  [`${mainCls}__links`]: {
    paddingBottom: 114,
    borderBottom: '1px solid #697684',
    [brpM]: {
      paddingBottom: 45,
    }
  },
  [`${mainCls}__links--cnt`]: {
    display: 'flex',
    flexFlow: 'row wrap',
    [brpM]: {
      width: 'calc(100% - 250px)',
    },
    '& a': {
      display: 'block',
      paddingBottom: 16,
      width: '50%',
      fontSize: 14,
      lineHeight: '22px',
      textTransform: 'uppercase',
      [brpM]: {
        marginRight: '3%',
        width: '30%',
        fontSize: 13,
      },
    },
  },
  [`${mainCls}__links--cnt--who`]: {
    order: 1,
  },
  [`${mainCls}__links--cnt--pri`]: {
    order: 5,
    [brpM]: {
      order: 2,
    },
  },
  [`${mainCls}__links--cnt--pub`]: {
    order: 4,
    [brpM]: {
      order: 3,
    },
  },
  [`${mainCls}__links--cnt--inf`]: {
    order: 3,
    [brpM]: {
      order: 4,
    },
  },
  [`${mainCls}__links--cnt--coo`]: {
    order: 9,
    [brpM]: {
      order: 5,
    },
  },
  [`${mainCls}__links--cnt--con`]: {
    order: 6,
  },
  [`${mainCls}__links--cnt--uff`]: {
    order: 2,
    [brpM]: {
      order: 7,
    },
  },
  [`${mainCls}__links--cnt--pre`]: {
    order: 11,
    [brpM]: {
      order: 8,
    },
  },
  [`${mainCls}__links--cnt--job`]: {
    order: 8,
    [brpM]: {
      order: 9,
    },
  },
  [`${mainCls}__links--cnt--spa`]: {
    display: 'none',
    // paddingBottom: 16,
    // lineHeight: '22px',
    // [brpM]: {
    //   order: 10,
    //   display: 'block',
    //   marginRight: '3%',
    //   width: '30%',
    // },
  },
  [`${mainCls}__links--cnt--sic`]: {
    order: 7,
    [brpM]: {
      order: 11,
    },
  },
  [`${mainCls}__links--cnt--app`]: {
    order: 10,
    [brpM]: {
      order: 12,
    },
  },
  [`${mainCls}__links--cnt--admin`]: {
    order: 11,
    [brpM]: {
      order: 10,
    },
  },

  [`${mainCls}__share_infos`]: {
    display: 'flex',
    flexDirection: 'column',
    [brpM]: {
      flexDirection: 'row',
      paddingTop: 75,
      '&.fourLines': {
        paddingTop: 37,
      },
    },
  },
  [`${mainCls}__share`]: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '40px 0 40px',
    '& a': {
      display: 'block',
      width: 40,
      height: 40,
      textIndent: '-9999em',
    },
    [brpM]: {
      justifyContent: 'flex-end',
      order: 2,
      marginLeft: 'auto',
      padding: 0,
      width: 295,
      '& a': {
        marginLeft: 8,
      },
    },
  },
  [`${mainCls}__infos`]: {
    lineHeight: '22px',
    [brpM]: {
      order: 1,
      height: 40,
      lineHeight: '40px',
    },
  },
  [`${mainCls}__infos--idl`]: {
    display: 'block',
  },
  [wImages]: {
    [`&.${mainCls}`]: {
      '&::before': {
        background: `url(${getExtPath('common_images/footer/mappa_footer_low.jpg')}) 0 0 no-repeat`,
        backgroundSize: 'cover',
      },
    },
    [`& .${mainCls}__links`]: {
      background: `url(${getExtPath('common_images/footer/logoWhite2024.svg')}) 0 calc(100% - 40px) no-repeat`,
      backgroundSize: '200px auto',
      [brpM]: {
        background: `url(${getExtPath('common_images/footer/logoWhite2024.svg')}) right 40px no-repeat`,
        backgroundSize: '200px auto',
      },
    },
    [`& .${mainCls}__share`]: {
      '& a': {
        backgroundSize: '40px 40px !important',
        '&.fb': {
          background: `url(${getExtPath('common_images/footer/new/facebook.svg')}) 0 0 no-repeat`,
        },
        '&.tw': {
          background: `url(${getExtPath('common_images/footer/new/x.svg')}) 0 0 no-repeat`,
        },
        '&.yt': {
          background: `url(${getExtPath('common_images/footer/new/youtube.svg')}) 0 0 no-repeat`,
        },
        '&.in': {
          background: `url(${getExtPath('common_images/footer/new/linkedin.svg')}) 0 0 no-repeat`,
        },
        '&.is': {
          background: `url(${getExtPath('common_images/footer/new/instagram.svg')}) 0 0 no-repeat`,
        },
        '&.tg': {
          background: `url(${getExtPath('common_images/footer/new/telegram.svg')}) 0 0 no-repeat`,
        },
      },
      [brpM]: {
        order: 2,
        marginLeft: 'auto',
        padding: 0,
        width: 295,
      },
    },
  },
};
